/*
    VIEWS
 */
const assignmentPlansWrapperView = () => import('@/views/studentadministration/assignmentPlansWrapperView')
const studentAdministrationExamView = () => import('@/views/studentadministration/studentAdministrationExamView')
const studentAdministrationGroups = () => import('@/views/studentadministration/studentAdministrationGroups')
const studentAdministrationMoodle = () => import('@/views/studentadministration/studentAdministrationMoodle')
const studentAdministrationPermissions = () => import('@/views/studentadministration/studentAdministrationPermissions')
const studentAdministrationSettings = () => import('@/views/studentadministration/studentAdministrationSettings')
const studentAdministrationStatistics = () => import('@/views/studentadministration/studentAdministrationStatistics')
const studentAdministrationEvaluations = () => import('@/views/studentadministration/studentAdministrationEvaluations')
const studentAdministrationUMS = () => import('@/views/studentadministration/studentAdministrationUMS')
const studentAdministrationUsers = () => import('@/views/studentadministration/studentAdministrationUsers')
const studentAdministrationAdminUsers = () => import('@/views/studentadministration/studentAdministrationAdminUsers')
const studentAdministrationCounsellors = () => import('@/views/studentadministration/studentAdministrationCounsellors')

const studentAdministrationMaternityLeave = () => import('@/views/studentadministration/studentAdministrationMaternityLeave')
const studentAdministrationExcludedGroups = () => import('@/views/studentadministration/studentAdministrationExcludedGroups')
const studentAdministrationFixStudents = () => import('@/views/studentadministration/studentAdministrationFixStudents')

export default [
    {
        path: 'assignment-plans',
        component: assignmentPlansWrapperView,
        meta: { requiresAuth: true, view : 'student-administration-assignment-plans' },
    },
    {
        path: 'exam',
        component: studentAdministrationExamView,
        meta: { requiresAuth: true, view : 'student-administration-exam' },
    },
    {
        path: 'groups',
        component: studentAdministrationGroups,
        meta: { requiresAuth: true, view : 'student-administration-groups' },
    },
    {
        path: 'moodle',
        component: studentAdministrationMoodle,
        meta: { requiresAuth: true, view : 'student-administration-moodle' },
    },
    {
        path: 'permissions',
        component: studentAdministrationPermissions,
        meta: { requiresAuth: true, view : 'student-administration-permissions' },
    },
    {
        path: 'settings',
        component: studentAdministrationSettings,
        meta: { requiresAuth: true, view : 'student-administration-settings' },
    },
    {
        path: 'statistics',
        component: studentAdministrationStatistics,
        meta: { requiresAuth: true, view : 'student-administration-statistics' },
    },
    {
        path: 'evaluations',
        component: studentAdministrationEvaluations,
        meta: { requiresAuth: true, view : 'student-administration-evaluations' },
    },
    {
        path: 'UMS',
        component: studentAdministrationUMS,
        meta: { requiresAuth: true, view : 'student-administration-UMS' },
    },
    {
        path: 'users',
        component: studentAdministrationUsers,
        meta: { requiresAuth: true, view : 'student-administration-users' },
    },
    {
        path: 'admin-users',
        component: studentAdministrationAdminUsers,
        meta: { requiresAuth: true, view : 'student-administration-admin-users' },
    },
    {
        path: 'maternity-leave',
        component: studentAdministrationMaternityLeave,
        meta: {
            requiresAuth: true,
            view : 'student-administration-maternity-leave'
        },
    },
    {
        path: 'counsellors',
        component: studentAdministrationCounsellors,
        meta: {
            requiresAuth: true,
            view : 'student-administration-counsellors',
            requiresInstitutionSetting: {
                name: 'allow-counsellors',
                value: '1',
                pathIfFail: '/403'
            }
        },
    },
    {
        path: 'excluded-groups',
        component: studentAdministrationExcludedGroups,
        meta: {
            requiresAuth: true,
            view : 'student-administration-excluded-groups',
            // Gated by an institution setting (mirrors `allow-counsellors`)
            // instead of the old hard-coded institution 111647 check.
            // NB: inst 111647 (HF&VUC Nord) must have
            // `allow-excluded-archived-groups=1` seeded at prod cutover to keep
            // its existing access — the backend only checks admin_groups_classes.
            requiresInstitutionSetting: {
                name: 'allow-excluded-archived-groups',
                value: '1',
                pathIfFail: '/403'
            }
        },
    },
    {
        path: 'fix-students',
        component: studentAdministrationFixStudents,
        meta: {
            requiresAuth: true,
            view : 'student-administration-fix-students'
        },
    },
]
